module.exports = __webpack_public_path__ + "img/fa-question.ae10e706.svg";